export default __webpack_public_path__ + "static/media/Group3.ac743ecd.svg";